import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Table, Tooltip } from "antd";
import axios from "axios";
import { AuditOutlined, AlertOutlined } from "@ant-design/icons";
import moment from "moment";
// import {
//   CustomerOrderInfo,
//   PermissionInfo,
//   UserInfo,
// } from "../../../../context";
import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
import { UserInfo } from "../../../../context";
import DialogTeamLeaderUpdateCashCount from "../../../../utils/merchant-employee/DialogTeamLeaderUpdateCashCount";
import CashierSummary from "../../cashiering/cash-count/CashierSummary";
import DialogExpenseCashCount from "../../cashiering/cash-count/expense";
// import MerchantEmployeeLayout from "../../../layout/MerchantEmployeeLayout";
// import DialogCashCount from "../../../../utils/merchant-employee/DialogCashCount";

const MerchantEmployeeTeamLeaderCashCount = () => {
  const tableLayout = "";
  const scroll = {};
  const { userData } = useContext(UserInfo);
  const [openModal, setOpenModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [infoModal, setInfoModal] = useState(false);
  const [openExpenseDialog, setOpenExpenseDialog] = useState(false);

  const [dailyCashFundList, setDailyCashFundList] = useState({
    data: [],
    ready: false,
  });

  const tableProps = {
    bordered: false,
    size: "medium",
    showHeader: true,
    scroll,
    tableLayout,
  };

  const columns = [
    {
      title: "Date",
      dataIndex: "created_at",
      render: (text, record) => (
        <p
          style={{
            fontWeight: "bold",
          }}
        >
          {moment(`${text.replace(" ", "T")}`)
            .utc()
            .format("MMM DD, YYYY")}
        </p>
      ),
    },
    {
      title: "Total Cash Funds",
      dataIndex: "cf_total",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Cash Counts",
      dataIndex: "g_total",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Expense",
      dataIndex: "daily_expense",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Total Sales",
      dataIndex: "daily_sales",
      render: (text, record) => <p style={{ textAlign: "right" }}>{text}</p>,
    },
    {
      title: "Status",
      dataIndex: "",
      render: (text, record) => (
        <p style={{ textAlign: "center" }}>
          {text.g_total === "0.00"
            ? "Waiting"
            : parseFloat(
                parseFloat(text.cf_total) +
                  parseFloat(text.daily_sales) -
                  parseFloat(text.daily_expense)
              ) === parseFloat(text.g_total)
            ? "Exact"
            : parseFloat(text.g_total) >
              parseFloat(
                parseFloat(text.cf_total) +
                  parseFloat(text.daily_sales) -
                  parseFloat(text.daily_expense)
              )
            ? "Over"
            : "Short"}
        </p>
      ),
    },
    {
      title: "",
      dataIndex: "",
      align: "center",
      width: 110,
      render: (text) => (
        <p style={{ width: window.innerWidth > 883 ? "auto" : 110 }}>
          {text.g_total === "0.00" && (
            <>
              <Tooltip title="Update">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSelectedData(text);
                    setOpenModal(true);
                  }}
                  icon={<AuditOutlined />}
                  disabled={text.g_total !== "0.00"}
                  style={{ marginRight: 5 }}
                />
              </Tooltip>
              <Tooltip title="Expense Details">
                <Button
                  type="dashed"
                  shape="circle"
                  onClick={() => {
                    setSelectedData(text);
                    setOpenExpenseDialog(true);
                  }}
                  icon={<AlertOutlined />}
                  // disabled={text.g_total !== "0.00"}
                />
              </Tooltip>
            </>
          )}

          {text.g_total !== "0.00" && (
            <Tooltip title="Summary">
              <Button
                type="dashed"
                shape="circle"
                onClick={() => {
                  setSelectedData(text);
                  setInfoModal(true);
                }}
                icon={<AuditOutlined />}
                style={{ marginRight: 5 }}
                // disabled={text.g_total !== "0.00"}
              />
            </Tooltip>
          )}
        </p>
      ),
    },
  ];

  const tableColumns = columns.map((item) => ({
    ...item,
    ellipsis: false,
  }));

  const getDailyCashFundList = useCallback(() => {
    var params = {
      user_id: userData.data.id,
      merchant_user_id: userData.data.usersmerchantemployee.merchant_user_id,
    };
    axios
      .get("user/merchant-employee/tl/cash-count-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setDailyCashFundList({ data: data, ready: true });
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.usersmerchantemployee.merchant_user_id]);

  useEffect(() => {
    getDailyCashFundList();
  }, [getDailyCashFundList]);

  return (
    <MerchantEmployeeLayout>
      <div style={{ overflowX: "auto" }}>
        <Table
          {...tableProps}
          pagination={{
            position: ["bottomCenter"],
          }}
          columns={tableColumns}
          dataSource={
            dailyCashFundList.data.length > 0 ? dailyCashFundList.data : []
          }
          scroll={scroll}
          rowKey={(record) => record.id}
        />
      </div>

      {openModal && (
        <DialogTeamLeaderUpdateCashCount
          open={openModal}
          close={() => setOpenModal(false)}
          rerun={() => getDailyCashFundList()}
          selectedData={selectedData}
          //   totalSales={totalSales}
        />
      )}

      {openExpenseDialog && (
        <DialogExpenseCashCount
          open={openExpenseDialog}
          close={() => setOpenExpenseDialog(false)}
          selectedData={selectedData}
        />
      )}

      {infoModal && (
        <CashierSummary
          open={infoModal}
          close={() => setInfoModal(false)}
          selectedData={selectedData}
        />
      )}
    </MerchantEmployeeLayout>
  );
};

export default MerchantEmployeeTeamLeaderCashCount;
